import instance from './api';

export const postGetUsers = async (id: number) => {
  const { data } = await instance.post('users', { org_id: id });

  return data;
};
